import { createContext, useContext, type ReactNode } from 'react'
import { loadKeyOf } from '../results/loadKey'
import type { StoredAssign, StoredAssigns } from './storedAssigns'

const StoredAssignsContext = createContext<StoredAssigns>({})

/** The chat's stored assigns, for the load rows it draws: a row shows the truck its stored write left on the load. */
export const StoredAssignsProvider = ({ assigns, children }: { assigns: StoredAssigns; children: ReactNode }) => (
    <StoredAssignsContext.Provider value={assigns}>{children}</StoredAssignsContext.Provider>
)

/** The stored assign of one load, or undefined when no stored write of this chat names it. */
export const useStoredAssign = (loadId: string, loadNumber: string | null | undefined): StoredAssign | undefined => {
    const assigns = useContext(StoredAssignsContext)
    const key = loadKeyOf({ load_id: loadId, load_number: loadNumber })
    return key === undefined ? undefined : assigns[key]
}
